// Okta configurations
export const ISSUER = "https://aptive.okta.com/oauth2/default";
export const CLIENT_ID = "0oa890nrho6lshm6T697";
export const SCOPES = ["openid", "profile", "email", "AppGenesys"];
export const STATE = "Genesys";
